import { RouteType } from "types/RouteType";

/**
 * Custom Report Builder Route
 * Allows users to create and run custom reports (Phase 5)
 *
 * KEY FEATURES:
 * - User-configurable report columns and filters
 * - Multiple data source support
 * - Plant ID filtering and subtotaling
 * - Scheduling for recurring reports
 */
export const reportBuilderRoute: RouteType = {
  name: "Report Builder",
  path: "/accounting/reports/builder",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Custom Report Builder",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./ReportBuilder.Header"),
    },
    body: {
      component: () => import("./ReportBuilder.Body"),
      grayBackground: true,
    },
  },
  dialogs: [
    {
      name: "ReportDefinitionDialog",
      title: "Report Configuration",
      component: () => import("./ReportDefinitionDialog"),
      fullWidth: true,
    },
    {
      name: "ColumnConfigDialog",
      title: "Configure Columns",
      component: () => import("./ColumnConfigDialog"),
      fullWidth: true,
    },
    {
      name: "FilterConfigDialog",
      title: "Configure Filters",
      component: () => import("./FilterConfigDialog"),
      fullWidth: true,
    },
  ],
  group: "Accounting Reports",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

export default reportBuilderRoute;
